import axios from 'axios';
import service from './http';
import {
  GenerateRandomKey,
  StringToBase64,
  AesEncrypt,
  AesDecrypt,
  GetLocalStorage,
  RSAEncrypt,
  RSADecrypt,
  Base64ToString
} from '../utils/tool';
import SecretKey from './key';

//随机生成32位，并使用钥匙对请求参数进行AES加密
const get_random_to_base64 = (data) => {
  //随机生成32字符
  const random_key_32 = GenerateRandomKey();
  //随机生成32字符转base64
  const random_key_32_to_base64 = StringToBase64(random_key_32);
  //数据转JSON字符串
  const data_string = typeof data == 'object' ? JSON.stringify(data) : String(data);
  //AES 加密数据
  const AES_encrypt_data = AesEncrypt(data_string, random_key_32);

  return { AES_encrypt_data, random_key_32_to_base64 };
};
//增加请求header 参数
export const request_get_token = () => {
  const token = GetLocalStorage('firmServiceToken');
  service.defaults.headers.common.Authorization = `Bearer ${token}`;
};
const is_online = () => {
  let origin = window.location.origin;
  if (origin.indexOf('utaxes.com') != -1) {
    return true;
  } else {
    return false;
  }
};
//请求参数加密
export const request_param_handle = (param, type) => {
  let request_type = type ? axios : service;
  let mode = is_online();
  let REQUEST_KEY_TXT = SecretKey.REQUEST_TO_DECRYPT_PRIVATE_KEY;
  let REQUEST_KEY_PRO = SecretKey.PRO_REQUEST_TO_DECRYPT_PRIVATE_KEY;

  let keys = mode ? REQUEST_KEY_PRO : REQUEST_KEY_TXT;
  const { AES_encrypt_data, random_key_32_to_base64 } = get_random_to_base64(param);
  // 公钥
  const key = '-----BEGIN PUBLIC KEY-----\n' + keys + '\n-----END PUBLIC KEY-----';
  const encrypt_RSA_KAY = RSAEncrypt(key, random_key_32_to_base64);
  const token = GetLocalStorage('firmServiceToken');
  request_type.defaults.headers.common['encrypt-key'] = encrypt_RSA_KAY;
  request_type.defaults.headers.common['Content-Type'] = 'application/json';
  request_type.defaults.headers.common.Authorization = `Bearer ${token}`;
  return { AES_encrypt_data };
};
//响应体解密
export const response_param_handle = (data, header) => {
  const encrypt_key = header['encrypt-key'];
  let mode = is_online();
  let RESPONSE_KEY_TXT = SecretKey.RESPONSE_TO_ENCRYPTED_PUBLIC_KEY;
  let RESPONSE_KEY_PRO = SecretKey.PRO_RESPONSE_TO_ENCRYPTED_PUBLIC_KEY;
  let keys = mode ? RESPONSE_KEY_PRO : RESPONSE_KEY_TXT;
  const decrypt_key = '-----BEGIN PUBLIC KEY-----\n' + keys + '\n-----END PUBLIC KEY-----';
  const RSA_decrypt_Result = RSADecrypt(decrypt_key, encrypt_key);
  const Key_Base64_to_String = Base64ToString(RSA_decrypt_Result);
  const result_json_string = AesDecrypt(data, Key_Base64_to_String);
  const result_json = JSON.parse(result_json_string);
  return { result_json };
};

// 只加密密码字段（使用纯 RSA 加密）
export const encryptPasswordField = (password) => {
  // Use environment variable to control which key to use
  // If REACT_APP_USE_PROD_KEY is 'true', use production key, otherwise use development key
  const useProdKey = process.env.REACT_APP_USE_PROD_KEY === 'true';
  let REQUEST_KEY_TXT = SecretKey.REQUEST_TO_DECRYPT_PRIVATE_KEY;
  let REQUEST_KEY_PRO = SecretKey.PRO_REQUEST_TO_DECRYPT_PRIVATE_KEY;
  let keys = useProdKey ? REQUEST_KEY_PRO : REQUEST_KEY_TXT;

  // 直接用 RSA 公钥加密密码
  const publicKey = '-----BEGIN PUBLIC KEY-----\n' + keys + '\n-----END PUBLIC KEY-----';
  const encryptedPassword = RSAEncrypt(publicKey, password);

  return encryptedPassword;
};
